import './PageHeader.css'

import type { ReactNode } from 'react'

import { cx } from '../utilities/cx'

export type PageHeaderProps = {
  className?: string
  title: string
  subtitle?: string
  actions?: ReactNode
  children?: ReactNode
}

export const PageHeader = (props: PageHeaderProps) => {
  const { className, title, subtitle, actions, children } = props

  return (
    <header className={cx('page-header', className)}>
      <div className="page-header__row">
        <div className="page-header__text">
          <h1 className="page-header__title">{title}</h1>
          {subtitle && <p className="page-header__subtitle">{subtitle}</p>}
        </div>
        {actions && <div className="page-header__actions">{actions}</div>}
      </div>
      {children}
    </header>
  )
}
